import React from "react";
import CommonRow from "../common-row";

const NineStories = props => {
  return <CommonRow {...props} />;
};

export default NineStories;
